import { Box, Skeleton, Flex } from '@chakra-ui/react';

const DashboardSkeleton = () => {
    return (
        <Box
            flex={1}
            border="1px solid"
            borderColor="gray.200"
            borderRadius="lg"
            overflow="hidden"
        >
            {/* Table Header */}
            <Flex bg="gray.50" p={3} borderBottom="1px solid" borderColor="gray.200">
                {Array(6).fill(0).map((_, i) => (
                    <Box key={i} flex={i === 0 || i === 1 ? 2 : 1} px={2}>
                        <Skeleton height="12px" width="70px" borderRadius="md" />
                    </Box>
                ))}
            </Flex>

            {/* Table Rows */}
            {Array(12).fill(0).map((_, rowIdx) => (
                <Flex
                    key={rowIdx}
                    p={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    align="center"
                >
                    {Array(6).fill(0).map((_, colIdx) => (
                        <Box key={colIdx} flex={colIdx === 0 || colIdx === 1 ? 2 : 1} px={2}>
                            <Skeleton
                                height="16px"
                                width={colIdx === 0 ? "85%" : colIdx === 5 ? "80px" : "65%"}
                                borderRadius="md"
                            />
                        </Box>
                    ))}
                </Flex>
            ))}
        </Box>
    );
};

export default DashboardSkeleton;
